import { type ICombinedState } from '../reducers';

export const companySelector = (state: ICombinedState) => state.company.company;
